import { PersistentStorage } from "@/lib/tour/persistent-storage/storage";
import { ChecklistTerminateReason, TourLifecycleManager, TourTerminateReason } from "@/lib/tour/tourLifecycleManager";
import { navigateTo } from "@/lib/window";
import { store } from "@/store";
import { makeAutoObservable } from "mobx";

export class PreviewManager {
  storage: PersistentStorage;
  tourLifecycleManager!: TourLifecycleManager;

  constructor({
    storage,
    tourLifecycleManager,
  }: {
    storage: PersistentStorage;
    tourLifecycleManager: TourLifecycleManager;
  }) {
    makeAutoObservable(this);
    this.storage = storage;
    this.tourLifecycleManager = tourLifecycleManager;
  }

  terminateCurrentTour(reason: TourTerminateReason) {
    this.tourLifecycleManager.terminateCurrentTour(reason);
  }

  terminateCurrentChecklist(reason: ChecklistTerminateReason) {
    this.tourLifecycleManager.terminateCurrentChecklist(reason);
  }

  restartPreview() {
    const previewGuideId = this.storage.previewState.getGuideId();
    const initialUrl = this.storage.previewState.get().initialUrl;
    if (previewGuideId) {
      if (this.tourLifecycleManager.currentTour) {
        this.terminateCurrentTour("restart_preview");
        this.storage.previewState.clear();
      }
      if (initialUrl) {
        navigateTo(initialUrl);
        return true;
      }
    }
    return false;
  }

  closePreview() {
    store.disableDebug();
    this.storage.previewState.clear();
    const url = new URL(window.location.href);
    url.searchParams.delete("pyne-guide-id");
    url.searchParams.delete("pyne-checklist-id");
    window.history.replaceState({}, "", url);

    if (this.tourLifecycleManager.currentTour) {
      this.terminateCurrentTour("close_preview");
    }

    if (this.tourLifecycleManager.currentChecklist) {
      this.terminateCurrentChecklist("close_preview");
    }

    store.disablePreview();
  }
}
